<template>
  <div id="app">
    <div v-if="isLoading"></div>
    <div v-else>
      <div class="container">
        <router-view />
      </div>
    </div>
  </div>
</template>
<script>
import EventBus from "@/EventBus"
export default {
  data: () => ({
    isLoading: true
  }),
  mounted() {
    EventBus.$on("i18n-load-start", () => (this.isLoading = true))
    EventBus.$on("i18n-load-complete", () => (this.isLoading = false))
  },
}
</script>